import { styledStatusText, styledStatusWrapper } from './ItemCardStatus.styled';

import ClubStatus from '@/common/components/ClubStatus/ClubStatus';
import { Resource } from '@/generated/contentfulTypes';
import {
  BannerTextLocation,
  BannerTextLocationVariants,
} from '../../utils/ItemCard.interface';
import { Maybe } from 'graphql/jsutils/Maybe';

export default function ItemCardStatus({
  status,
  hideArrow,
  bannerTextLocation,
}: {
  status: Resource;
  hideArrow?: boolean;
  bannerTextLocation?: Maybe<BannerTextLocation>;
}) {
  const textLocation =
    bannerTextLocation === BannerTextLocationVariants.Side
      ? 'vertical'
      : 'horizontal';

  return (
    <ClubStatus
      hideArrow={hideArrow}
      status={status}
      wrapperStyles={styledStatusWrapper}
      textStyles={styledStatusText}
      textLocation={textLocation}
    />
  );
}
